import createTheme from '@/themes/createTheme.ts'

const theme = {
  mainColor: '#0053CF', // 主题色 #13655B 绿色
  visionColor: '#e6f4ff', // 主题 衍生色  按钮背景  hover等效果
  rowSelectedBg: '#F0F6FF',
  rowSelectedHoverBg: '#E3EEFF', // 主题 衍生色  按钮背景  hover等效果
  headerIconBorder: '#91caff', //  导航图标边框
  headerIconBg: '#4096ff', //  导航图标背景
}

export default createTheme(theme)
